import SEO from "../components/SEO";
import PageHero from "../components/shared/PageHero";
import Eyebrow from "../components/shared/Eyebrow";
import TypedHeading from "../components/shared/TypedHeading";
import Reveal from "../components/shared/Reveal";
import TechMarquee from "../components/shared/TechMarquee";
import CtaBanner from "../components/shared/CtaBanner";
import { smoothScrollToId } from "../utils/scrollToHash";
import useI18n from "../i18n/useI18n";

const BLOCK_IDS = ["svc-web", "svc-mobile", "svc-ai", "svc-consulting"];

const handleSpotlight = (event) => {
  const card = event.currentTarget;
  const rect = card.getBoundingClientRect();
  card.style.setProperty("--mx", `${event.clientX - rect.left}px`);
  card.style.setProperty("--my", `${event.clientY - rect.top}px`);
};

const ServicesPage = () => {
  const { t } = useI18n();
  const blocks = t("servicesPage.blocks");
  const models = t("servicesPage.models");

  return (
    <div className="services-page">
      <SEO title={`CodeIL · ${t("nav.services")}`} description={t("servicesPage.lede")} path="/services" />

      <PageHero eyebrow={t("servicesPage.eyebrow")} titleWords={t("servicesPage.title")} lede={t("servicesPage.lede")}>
        <div className="services-page__jump">
          {Array.isArray(blocks) &&
            blocks.map((block, i) => (
              <a
                key={i}
                href={`#${BLOCK_IDS[i]}`}
                className="services-page__chip"
                onClick={(event) => {
                  event.preventDefault();
                  smoothScrollToId(BLOCK_IDS[i]);
                }}
              >
                {block.num} · {block.chip}
              </a>
            ))}
        </div>
      </PageHero>

      <TechMarquee />

      {Array.isArray(blocks) &&
        blocks.map((block, i) => (
          <section
            id={BLOCK_IDS[i]}
            key={i}
            className={`section svc-block${i % 2 === 1 ? " section--alt" : ""}`}
          >
            <div className="svc-block__inner">
              <div className="svc-block__aside">
                <Reveal as="div" className="svc-block__bignum">{block.num}</Reveal>
                <TypedHeading text={block.title} className="svc-block__title" />
                <Reveal as="p" className="svc-block__desc">{block.desc}</Reveal>
                <Reveal className="svc-block__tags">
                  {block.tags.map((tag, ti) => (
                    <span className="svc-tag" key={ti}>{tag}</span>
                  ))}
                </Reveal>
              </div>
              <div className="svc-block__rows">
                {block.rows.map((row, ri) => (
                  <Reveal as="div" className="svc-row" key={ri}>
                    <span className="svc-row__num">{String(ri + 1).padStart(2, "0")}</span>
                    <div>
                      <div className="svc-row__title">{row.title}</div>
                      <p className="svc-row__desc">{row.desc}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </section>
        ))}

      {/* Engagement models */}
      <section className="section svc-models">
        <div className="svc-models__inner">
          <Reveal><Eyebrow>{t("servicesPage.modelsEyebrow")}</Eyebrow></Reveal>
          <TypedHeading text={t("servicesPage.modelsTitle")} className="svc-models__title" />
          <Reveal as="p" className="svc-models__lede">{t("servicesPage.modelsLede")}</Reveal>
          <div className="svc-models__grid">
            {Array.isArray(models) &&
              models.map((model, i) => (
                <Reveal as="article" className="model-card" key={i}>
                  <div className="model-card__hit" onMouseMove={handleSpotlight}>
                    <div className="spot" aria-hidden="true" />
                    <div className="model-card__body">
                      <div className="model-card__key">{model.key}</div>
                      <h3 className="model-card__title">{model.title}</h3>
                      <p className="model-card__desc">{model.desc}</p>
                      <div className="model-card__fit">{model.fit}</div>
                    </div>
                  </div>
                </Reveal>
              ))}
          </div>
        </div>
      </section>

      <CtaBanner
        title={t("servicesPage.ctaTitle")}
        lede={t("servicesPage.ctaLede")}
        primary={{ label: t("servicesPage.ctaPrimary"), kind: "anchor", target: "ai" }}
        secondary={{ label: t("servicesPage.ctaSecondary"), kind: "anchor", target: "projects" }}
      />
    </div>
  );
};

export default ServicesPage;
